module.exports = __webpack_public_path__ + "static/media/quote-right.b18a6d20.svg";